import { toCurrency, toPoints } from '@/shared/helpers'
export const TABLE_COLUMNS = [
  {
    Header: "Redemption Date",
    accessor: "redemption_date",
    Cell: ({ value }) => {
      let date = new Date(value).toLocaleDateString("en-US", {});
      return <span>{date}</span>;
    },
  },
  {
    Header: "Program",
    accessor: "program_name",
  },
  {
    Header: "Employee Id",
    accessor: "employee_id",
  },
  {
    Header: "First Name",
    accessor: "first_name",
  },
  {
    Header: "Last Name",
    accessor: "last_name",
  },
  {
    Header: "Email",
    accessor: "u_email",
  },
  {
    Header: "Merchant Name",
    accessor: "merchant_name",
  },
  {
    Header: "Points Redeemed",
    accessor: "redemption_points",
    Cell: ({ row, value }) => { return toPoints(value) },
  },
  {
    Header: "Redemption Value",
    accessor: "redemption_value",
    Cell: ({ row, value }) => { return toCurrency(value) },
  },

];
